
export function formatTimeHMS(sec: number): string {
  return [sec >= 3600 ? Math.floor(sec / 3600) : null, Math.floor((sec % 3600) / 60), sec % 60]
    .filter((val) => val !== null)
    .map((val, index) => {
      return index === 0 ? val!.toString() : val!.toString().padStart(2, '0');
    })
    .join(':');
}

export function createDate(dateStr: string): Date {
  const testExp = /(\d{4}(-|\/)\d{2}(-|\/)\d{2})\b/g;

  if (testExp.test(dateStr.replace(" ", "_"))) {
    return new Date(dateStr + "T00:00:00.0000");
  }

  return new Date(dateStr);
}
